 import React from "react";
import "./privacy.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from '../../containers/footer/Footer'
const Privacy = () => {
  window.scrollTo(0, 0);
  return (
    <>
    <div className="bck">
      <Navbar />
      <div class="prvc">
        <p>
          Jain Auto Corp. Pvt. ltd. (“Jain Auto Corporation “) is concerned about
          the privacy of its users (hereinafter referred to as “You” “Your”
          “Yourself”) accessing its website located at{" "}
          <a href="/">jainAutoCorp.com </a>and
          has provided this Privacy Policy (“Policy”) to familiarize You with
          the manner in which Jain Auto Corp. Pvt. ltd. collects, uses and
          discloses Your information collected through the Website. By using the
          website, you agree to the terms and conditions of this policy. If you
          do not agree with the terms and conditions of this policy, please do
          not proceed further to use this website.
        </p>
        <p></p>
        <h1>1.&nbsp;&nbsp;&nbsp; Information and Usage</h1>
        <p></p>
        <p>
          This Privacy Policy explains how Jain Auto Corp. Pvt. ltd.
          collects personal and non-personal information, classified as
          mandatory or voluntary and uses, discloses and protects such
          information through the Website. ‘Personal Information’ is data that
          can be used to uniquely identify or contact a single person (“Personal
          Information”). Personal Information for the purposes of this Policy
          shall include, but not limited to, information regarding Your name,
          address, telephone number, date of birth, gender, E-Mail address, etc.
        </p>
        <p>
          You may need to provide Jain Auto Corp. Pvt. ltd. Your Personal
          Information during the course of using some services of the Jain COrporation  for instance, creating a User ID, provide
          information in Your account while registering on the Website, or
          provide financial information while making an online purchase, upload
          content, participate in any online survey or contest, communicate with
          Jain Auto Corp. Pvt. ltd.‘s customer service by phone, E-Mail or
          otherwise, provide reviews for the content available on the Website.
        </p>
        <p>
          Jain Auto Corp. Pvt. ltd. collects only such Personal
          Information that Jain Auto Corp. Pvt. ltd. believes to be
          relevant and is required to understand you or your interests. Jain Auto Corporation  collects Your Personal Information in order to
          record, support and facilitate Your participation in the activities
          You select,&nbsp;
          <span  >
            track Your preferences, to provide You with a customized Website
            experience, to notify You of any updated information and new
            activities and other related functions offered by Jain Auto Corporation
            Mobility Pvt. Ltd., keep You informed about latest content available
            on the Website, special offers, and other products and services of
            Jain Auto Corp. Pvt. ltd., to assist You with customer service
            or technical support issues, to follow up with You after Your visit,
            to otherwise support Your relationship with Jain Auto Corporation Mobility
            Pvt. Ltd. or to prevent fraud and unlawful use&nbsp;
          </span>
          <span  >
            In an effort to make our Website effective, certain information may
            be collected each time you visit the Website. Such information may
            be stored in server logs. These encrypted statistics do not identify
            you personally, but provide us the information regarding your visit
            to the Website and the type of user who is accessing our Website and
            certain browsing activities by You. This data may include: IP
            address of Your server from where the Website is being accessed, the
            type of browser (Internet Explorer, Firefox, Opera, Google Chrome
            etc.), the operating system of Your system and the Website You last
            visited before visiting to our Website. The duration of Your stay on
            our Website is also stored in the session along with the date and
            time of your access. These data are used by Jain Auto Corporation Mobility
            Pvt. Ltd. to understand the use and number of user visiting the
            Website.
          </span>
        </p>
        <p>
          Some of the information related to the Website and Your visit to the
          Website may be shared by and with the sponsors, investors,
          advertisers, developer, strategic business partners of Jain Auto Corporation
          Mobility Pvt. Ltd. and some associates in order to enhance and grow
          our business and the Website to which you give your irrevocable
          consent but we assure that these information will never include any of
          Your Personal Information. This anonymous information is collected
          through the use of a pixel tag, which is industry standard technology
          used by most major Websites.
        </p>
        <p>
          When You use the Website, Jain Auto Corp. Pvt. ltd.‘s servers
          (which may be hosted by a third party service provider) may collect
          information indirectly and automatically about Your activities on the
          Website; for instance by way of cookies and you give you irrevocable
          consent for the same and for the said process of information
          collection, Jain Auto Corp. Pvt. ltd. will not be held liable or
        </p>
        <p></p>
        <p>
          responsible in any manner whatsover. A cookie is a small amount of
          data that is sent to a user’s browser from a web server and is
          eventually stored on a user’s computer hard drive. This anonymous
          information is maintained distinctly and is not linked to the Personal
          Information You submit to Jain Auto Corp. Pvt. ltd..
        </p>
        <p>
          Whether You want Your web browser to accept cookies or not is up to
          You. If You haven’t changed Your computer’s settings, most likely Your
          browser already accepts cookies. If You choose to decline cookies, You
          may not be able to fully experience all features of the Website. You
          can also delete Your browser cookies or disable them entirely, but
          this may significantly impact Your experience with the Website and may
          make parts of the Website non functional or inaccessible. We recommend
          that You leave them turned on.
        </p>
        <p>
          We use “third-party“ service providers to serve ads on our behalf
          across the internet and sometimes on this Website. They may collect
          anonymous information about Your visits to our Website, and Your
          interaction with our products and services and for the said process
          Jain Auto Corp. Pvt. ltd. will not be held liable or responsible
          in any manner whatsoever. No personally identifiable information is
          collected or used in this process. They do not know the name, phone
          number, address, E-Mail address, or any personally identifying
          information about the user.
        </p>
        <p>
          Jain Auto Corp. Pvt. ltd. also uses the log file like other
          website servers which is the standard measures. They include internet
          protocol (IP) addresses, browser type, internet service provider
          (ISP), referring/exit pages, platform type, date/time stamp, and
          number of clicks. We use them to analyze trends, administer the site,
          track a user’s movement and gather broad demographic information for
          aggregate use. IP addresses, etc. are not linked to personally
          identifiable information.
        </p>
        <p>
          Jain Auto Corp. Pvt. ltd. DOES NOT trade or sell Your Personal
          Information in any manner, except as specified herein or if express
          consent is sought from you.
        </p>
        <p></p>
        <h1>Personal Information provided by You is used only:</h1>
        <p></p>
        <ul>
          <li>To facilitate Your use of the Website</li>
          <li>
            To respond to Your inquiries or fulfill Your requests for
            information about the various services
          </li>
          <li>
            To provide You with information about Jain Auto Corporation Mobility Pvt.
            Ltd.‘s products/services and to send You information, materials, and
            offers from Jain Auto Corporation Mobility Pvt.
          </li>
          <li>
            To send You important information regarding the Website, changes to
            Jain Auto Corp. Pvt. ltd.‘s terms, conditions, and policies
            and/or other administrative information
          </li>
          <li>
            To send You surveys and marketing communications that Jain Auto Corporation
            Mobility Pvt. Ltd. believes may be of interest to You
          </li>
          <li>
            To personalize Your experience on the Website and Jain Auto Corporation
            Mobility Pvt. Ltd.‘s other websites by presenting advertising,
            products and offers tailored to You
          </li>
          <li>
            To help You address Your problems with the Website including
            addressing any technical problems
          </li>
          <li>
            If You purchase any content or avail of any service from the
            Website, to complete and fulfil Your purchase, for example, to have
            Your payments processed, communicate with You regarding Your
            purchase and provide You with related customer service
          </li>
          <li>For proper administering of the Website</li>
          <li>
            To conduct internal reviews and data analysis for the Website (e.g.,
            to determine the number of visitors to specific pages within the
            Website)
          </li>
          <li>
            To improve the services, content and advertising on the Website[Text
            Wrapping Break](l) To protect the integrity of the Website and[Text
            Wrapping Break](m) To respond to judicial process and provide
            information to law enforcement agencies or in connection with an
            investigation on matters related to public safety, as permitted by
            law
          </li>
        </ul>
        <p>
          You acknowledge that apart from Your Personal Information, if You
          upload any content on the Website, such content may contain
          information including Personal Information and the same may be
          available to the other users of the Website. Jain Auto Corporation Mobility
          Pvt. Ltd. will not be liable for the said disclosure and dissemination
          of such Personal Information to any third parties in any manner
          whatsoever.
        </p>
        <p>
          Jain Auto Corp. Pvt. ltd. may disclose aggregated information
          about the use of the Website, but it will never contain Personal
          Information. Jain Auto Corp. Pvt. ltd. does not disclose
          Personal Information to third parties in the normal course of
          operations, unless provided herein. However, in situations when
          Jain Auto Corp. Pvt. ltd. is legally obligated to disclose
          information to the government or other third parties or under a Court
          order, Jain Auto Corp. Pvt. ltd. will do so.
        </p>
        <p>
          Jain Auto Corp. Pvt. ltd. implements standard measures to
          protect against unauthorized access to and unlawful interception of
          Personal Information. However, no internet site can fully eliminate
          security risks. Jain Auto Corp. Pvt. ltd. will not be liable for
          any illegal act of any third party which breaches the security
          settings of the website.
        </p>
        <p></p>
        <h1>2.&nbsp;&nbsp;&nbsp; Shared Personal Information</h1>
        <p></p>
        <p>
          You are required to submit Your information at the time of making an
          online purchase on the Website. Jain Auto Corp. Pvt. ltd. uses
          an online payment gateway that is operated by a third party and the
          information that You share with Jain Auto Corp. Pvt. ltd. is
          transferred and shared with such third party payment gateway operator.
          The said operator may also have access to Your online purchase
          history/details that You make from the Website. Jain Auto Corporation Mobility
          Pvt. Ltd. will not be liable in whatsoever manner for the information
          shared by You on the third party payment gateway operator.
        </p>
        <p></p>
      
        <p></p>
        <h1>3.&nbsp;&nbsp;&nbsp; Data User consent</h1>
        <p></p>
        <p>
          I give Jain Auto Corp. Pvt. Ltd. and/or its affiliated and group
          companies and/or their employees (collectively “Jain Auto Corporation Mobility
          Pvt Ltd.”), agents, and its Retail network my consent and permission
          to send me communication about their products and services, offers and
          promotions, events, research, news or any other communication related
          to Jain Auto Corporation through phone, SMS, written communication, E-Mail or
          any other legal means, from time to time. In light of the Telecom
          Regulatory Authority of India (TRAI) guidelines, I hereby authorize
          Jain Auto Corp. Pvt. Ltd. and its agents and its Retail network
          to communicate with me through the phone and/or SMS and I agree that I
          am explicitly soliciting communication from Jain Auto Corporation Mobility Pvt.
          Ltd. and its agents and its Retail network even if my number/numbers
          is/are registered in the National Do Not Call Registry By clicking on
          “Submit” I agree that Jain Auto Corporation can use, collect, receive, possess,
          store, handle, process, disclose, transfer and use my data within and
          outside of my country as stated in its Privacy Policy available at:
          privacy policy page link. I understand that should I change my mind
          and choose to not receive offers based on my previous orders and my
          interests, I can inform Jain Auto Corp. Pvt. Ltd. by sending an
          E-Mail to{" "}
          <a href="mailto: "> <strong> Mail me</strong> </a>at
          any time to stop using my contact information to contact me or to send
          me any offers.
        </p>
        <p></p>
        <h1>4.&nbsp;&nbsp;&nbsp; Links to Third Party Websites</h1>
        <p></p>
        <p>
          The Website and any E-Mail sent to You may also contain/display
          third-party advertisements and links to other websites or products and
          services. Jain Auto Corp. Pvt. Ltd. does not provide any
          Personal Information to these third-party websites or agents or
          advertisers, however Jain Auto Corp. Pvt. Ltd. reserves the
          right to share with You the advertisement mailers on behalf of any
          other parties. If You choose to open the said third party
          advertisements, Jain Auto Corp. Pvt. Ltd. will not be liable in
          any manner for the act/transaction/information sharing with the said
          third party.
        </p>
        <p>
          In the event a vehicle is listed at an incorrect price due to
          typographical, photographic, or error in pricing information, the
          company shall have the right to refuse or cancel any orders placed for
          vehicle listed at the incorrect price.
        </p>
       
        <p>
          The information provided by You to such third party websites shall be
          governed in accordance with the privacy policies of such websites and
          it is recommended that You review the privacy policy on any such
          websites prior to using such websites.
        </p>
        <p>
          These “third-party“ websites and advertisers may use technology to
          send the advertisements that appear on the Website directly to Your
          browser. In such cases, the third party websites or advertisers
          automatically receive Your IP address. They
        </p>
        <p></p>
       
        <p></p>
        <h1>5.&nbsp;&nbsp;&nbsp; Security</h1>
        <p></p>
       
        <p>
          Jain Auto Corp. Pvt. Ltd. is not responsible for any breach of
          security or for any actions of any third parties that receive Your
          Personal Information. The Website also linked to many other sites and
          we are not/shall be not responsible for their privacy policies or
          practices as it is beyond our control.
        </p>
        <p>
          Not with standing anything contained in this Policy or elsewhere,
          Jain Auto Corp. Pvt. Ltd. shall not be held responsible for any
          loss, damage or misuse of Your Personal Information, if such loss,
          damage or misuse is attributable to a Force Majeure Event (as defined
          below).
        </p>
        <p>
          A “Force Majeure Event” shall mean any event that is beyond the
          reasonable control of Jain Auto Corp. Pvt. Ltd. and shall
          include, without limitation, sabotage, fire, flood, explosion, acts of
          God, civil commotion, strikes or industrial action of any kind, riots,
          insurrection, war, acts of government, computer hacking,&nbsp;
          <span  >
            unauthorized access to computer data and storage device, computer
            crashes, breach of security and encryption, etc.
          </span>
        </p>
        <p></p>
        <h1>6.&nbsp;&nbsp;&nbsp; Disclosure</h1>
        <p></p>
        <p>
          Jain Auto Corp. Pvt. Ltd. will use information only in
          accordance with the Policy under which the information was collected
          unless we have received explicit authorization.
        </p>
        <p></p>
        <p>
          Jain Auto Corp. Pvt. Ltd. may disclose any information Jain Corporation may have about You (including Your identity) if Jain Auto Corporation
          Mobility Pvt. Ltd. determines that such disclosure is necessary in
          connection with any investigation or complaint regarding Your use of
          the Website, or to identify, contact or bring legal action against
          someone who may be causing injury to or interference with (either
          intentionally or unintentionally) Jain Auto Corp. Pvt. Ltd.‘s
          rights or property, or the rights or property of users of the Website,
          including Jain Auto Corp. Pvt. Ltd.‘s customers. Jain Auto Corporation
          Mobility Pvt. Ltd. reserves the right at all times to disclose any
          information that Jain Auto Corp. Pvt. Ltd. deems necessary to
          comply with any applicable law, regulation, legal process or
          governmental request.
        </p>
        <p>
          Notwithstanding anything contained in this Policy or elsewhere,
          Jain Auto Corp. Pvt. Ltd. shall not be held responsible for any
          loss, damage or misuse of Your Personal Information, if such loss,
          damage or misuse is attributable to a Force Majeure Event (as defined
          below).
        </p>
        <p>
          Jain Auto Corp. Pvt. Ltd. also may disclose Your information
          when Jain Auto Corp. Pvt. Ltd. determines that applicable law
          requires or permits such disclosure, including exchanging information
          with other companies and organizations for fraud protection purposes
        </p>
        <p>
          You acknowledge and agree that Jain Auto Corp. Pvt. Ltd. may
          preserve any communication by You with Jain Auto Corp. Pvt. Ltd.
          through the Website or any Service, and may also disclose such data if
          required to do so by law or if
        </p>
        <p></p>
        <p>
          Jain Auto Corp. Pvt. Ltd. determines that such preservation or
          disclosure is reasonably necessary to:
        </p>
        <p></p>
        <p>
          (1) comply with legal process; (2) enforce this Policy; (3) respond to
          claims that any such data violates the rights of others; or (4)
          protect the rights, property or personal safety of Jain Auto Corporation
          Mobility Pvt. Ltd., its employees, users of, or visitors to, the
          Website, and the public.
        </p>
        <p></p>
        <h1>7.&nbsp;&nbsp;&nbsp; User Discretion</h1>
        <p></p>
        <p>
          You can always choose not to provide information and in such cases, if
          the information required is classified as mandatory, You will not be
          able to avail of that part of the Services, features or content.
        </p>
        <p>
          You can add or update Your Personal Information on a regular basis.
          When You update information,  Jain Auto Corp. Pvt. Ltd. will keep
          a copy of the prior version for its records.
        </p>
        <p>
          Notwithstanding anything contained in this Policy or elsewhere,
           Jain Auto Corp. Pvt. Ltd. shall not be held responsible for any
          loss, damage or misuse of Your Personal Information, if such loss,
          damage or misuse is attributable to a Force Majeure Event (as defined
          below).
        </p>
        <p>
           Jain Auto Corp. Pvt. Ltd. may, send direct advertisement mailers
          to You at the address given by You which could contain details of the
          products or services displayed on  Jain Auto Corp. Pvt. Ltd. or
          of any third party not associated with Jain Auto Corporation Mobility Pvt.
          Ltd..
        </p>
        <p>
          You have the option to opt-out of this direct or third party mailer
           Jain Auto Corp. Pvt. Ltd. respects Your privacy and if You do
          not want to receive e-mail or other communications from Jain Auto Corporation
          Mobility Pvt. Ltd. , For any query or assistance, feel free to Contact
          Us.
        </p>
        <p>
          (If You do not want  Jain Auto Corp. Pvt. Ltd. to use Personal
          Information Pvt. Ltd., for any query or assistance, feel free to
          Contact Us. It is pertinent to mention
        </p>
        <p></p>
        <p>
          that the Disclosure Clause as mentioned herein above will be adhered
          to in any case.)
        </p>
        <p></p>
        <p>
          The ‘Help’ portion of the toolbar on most browsers will tell You how
          to prevent Your browser from accepting new cookies, how to have the
          browser notify You when You receive a new cookie, or how to disable
          cookies altogether. Further, You can also disable or delete similar
          data used by browser add-ons, such as Flash cookies, by changing the
          add-on’s settings or visiting the Website&nbsp; of its manufacturer.
          However, as cookies allow You to take advantage of some of the
          Website’s features, some of the Website’s features and services may
          not function properly if Your cookies are disabled. It is therefore,
          recommended that You leave the cookies turned on. For instance, if You
          block or otherwise reject  Jain Auto Corp. Pvt. Ltd.‘s cookies,
          You will not be able to add items to Your shopping cart, proceed to
          checkout, or download any of  Jain Auto Corp. Pvt. Ltd.‘s Content
          or avail of  Jain Auto Corp. Pvt. Ltd.‘s services that require
          You to log in.
        </p>
        <p></p>
        <h1>8.&nbsp;&nbsp;&nbsp; General Provisions</h1>
        <p></p>
        <p>
          By accessing the Website, You have agreed to the terms set out in this
          Policy. This Policy should be at all times read along with the Terms
          of Use of the Website.
        </p>
        <p></p>
        
        <p></p>
        <p>
          By using this Website and the products, content and services provided
          on the Website, You agree and acknowledge that Your Personal
          Information collected through the Website may be transferred across
          national boundaries and stored and processed in any the country around
          the world. You also acknowledge that in certain countries or with
          respect to certain activities, the collection, transfer, storage, and
          processing of Your information may be undertaken by trusted third
          party vendors or agents.
        </p>
        <p></p>
        <p>
          facilitate Jain Auto Corp.. in providing certain
          functions. Jain Auto Corp.. will not be liable in
          whatsoever manner for the information shared by You on the third party
          payment gateway operator.
        </p>
        <p></p>
        <p>
         Jain Auto Corp. Pvt. Ltd. may make changes to this Policy, from
          time to time atJain Auto Corp. Pvt. Ltd.‘s sole discretion or
          on account of changes in law, howeverJain Auto Corp. Pvt. Ltd.
          the revised Policy shall be made available on the Website. Your
          continued use of the Website, following changes to the Policy, will
          constitute Your acceptance of those changes.
        </p>
        <p>
          Jain Auto Corp. Pvt. Ltd. may E-Mail periodic reminders of the
          notices and conditions, unless You have instructed Jain Auto Corporation
          Mobility Pvt. Ltd. not to, but You should check the Website frequently
          to see recent changes. Notwithstanding the above, Jain Auto Corporation
          Mobility Pvt. Ltd. shall not be required to notify You of any changes
          made to the Policy.
        </p>
        <p>
          If You choose to visit the Website, Your visit and any dispute over
          privacy is subject to this Policy and the Website’s Terms of Use. In
          addition to the foregoing, any disputes arising under this Policy
          shall be governed by the laws of India.
        </p>
        <p>
          The ‘Help’ portion of the toolbar on most browsers will tell You how
          to prevent Your browser from accepting new cookies, how to have the
          browser notify You when You receive a new cookie, or how to disable
          cookies altogether. Further, You can also disable or delete similar
          data used by browser add-ons, such as Flash cookies, by changing the
          add-on’s settings or visiting the Website&nbsp; of its manufacturer.
          However, as cookies allow You to take advantage of some of the
          Website’s features, some of the Website’s features and services may
          not function properly if Your cookies are disabled. It is therefore,
          recommended that You leave the cookies turned on. For instance, if You
          block or otherwise reject Jain Auto Corp. Pvt. Ltd.‘s cookies,
          You will not be able to add items to Your shopping cart, proceed to
          checkout, or download any of Jain Auto Corp. Pvt. Ltd.‘s Content
          or avail of Jain Auto Corp. Pvt. Ltd.‘s services that require
          You to log in.
        </p>
        <p></p>
        <h1>9.&nbsp;&nbsp;&nbsp; Contact</h1>
        <p>
          For any query or assistance, feel free to Contact Us with subject line
          &#8211; PRIVACY POLICY &#8211;  Jain Auto Corp. pvt ltd.        </p>
        <p>All rights reserved.</p>{" "}
      </div>
      
    </div>
    < Footer />
    </>
  );
};

export default Privacy;
